export const ragOf = (pct) => {
  if (pct >= 90) return "green";
  if (pct >= 75) return "amber";
  return "red";
};

export const RAG_LABEL = { green: "Good assurance", amber: "Improvement required", red: "Significant gaps" };
export const RAG_STROKE = { green: "#34D399", amber: "#FBBF24", red: "#F87171" };
export const RAG_TEXT_DARK = { green: "text-emerald-300", amber: "text-amber-300", red: "text-red-300" };

export const previousScore = (history) => {
  if (history.length >= 2) return history[history.length - 2].score;
  if (history.length === 1) return history[0].score;
  return null;
};
